
export default {
  props: {
    hsrLink: {
      type: Object,
      required: true,
    },
    performanceLink: {
      type: Object,
      required: true,
    },
    equityLink: {
      type: Object,
      required: true,
    },
  },
  methods: {
    hoverEnter(targetShadow, targetBtn) {
      this.$gsap.to(targetShadow, {
        duration: 1,
        attr: { stdDeviation: 7 },
      })
      this.$gsap.to(targetBtn, {
        scale: 1.1,
        transformOrigin: 'center',
      })
    },
    hoverLeave(targetShadow, targetBtn) {
      this.$gsap.to(targetShadow, {
        duration: 1,
        attr: { stdDeviation: 0 },
      })
      this.$gsap.to(targetBtn, {
        scale: 1,
        transformOrigin: 'center',
      })
    },
    onClick(linkObj) {
      window.parent.location.href = linkObj.link
    },
  },
}
